import { useState } from "react";
import { api, errText } from "../lib/api";
import { useLanguage } from "../context/LanguageContext";
import { toast } from "sonner";
import { Loader2, Megaphone } from "lucide-react";

const AFTER = 3;

// Owner-only, once per lost-pet post: re-email every neighbour in the area 3+ days after it went live.
export function LostBoost({ listing, onChange }) {
  const { t, lang } = useLanguage();
  const [busy, setBusy] = useState(false);
  const start = new Date(listing.approved_at || listing.created_at);
  const days = Math.floor((Date.now() - start.getTime()) / 86400000);
  const left = AFTER - days;

  const boost = async () => {
    if (!window.confirm(t("lb_confirm"))) return;
    setBusy(true);
    try {
      const { data } = await api.post(`/listings/${listing.id}/boost-alert`);
      onChange(data);
      toast.success(t(data.lf_boost_count === 1 ? "lb_done_one" : "lb_done").replace("{n}", data.lf_boost_count));
    } catch (e) { toast.error(errText(e)); }
    finally { setBusy(false); }
  };

  if (listing.lf_boosted_at) {
    const d = new Date(listing.lf_boosted_at).toLocaleDateString(lang === "fr" ? "fr-CA" : "en-CA", { month: "short", day: "numeric" });
    return <p className="mt-2 text-xs text-slate-500 flex items-center gap-1.5" data-testid="lost-boost-done"><Megaphone size={13} className="text-red-600" /> {t(listing.lf_boost_count === 1 ? "lb_sent_one" : "lb_sent").replace("{date}", d).replace("{n}", listing.lf_boost_count ?? 0)}</p>;
  }
  return (
    <div className="mt-2 flex items-center gap-3 flex-wrap" data-testid="lost-boost">
      <button type="button" onClick={boost} disabled={busy || left > 0} data-testid="lost-boost-btn"
        className="h-9 px-4 rounded-xl bg-red-600 text-white text-sm font-semibold flex items-center gap-2 hover:bg-red-700 disabled:bg-slate-200 disabled:text-slate-500 transition-colors">
        {busy ? <Loader2 size={15} className="animate-spin" /> : <Megaphone size={15} />} {t("lb_btn")}
      </button>
      <span className="text-xs text-slate-500" data-testid="lost-boost-hint">
        {left > 0 ? t(left === 1 ? "lb_wait_one" : "lb_wait").replace("{n}", left) : t("lb_hint")}
      </span>
    </div>
  );
}
